var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVolume = function SvgVolume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.609 2.867c-.257-.164-.609-.07-.773.188a.563.563 0 00.164.773A3.155 3.155 0 0112.5 6.5 3.163 3.163 0 0111 9.195a.564.564 0 00-.164.774c.141.258.492.351.773.187A4.337 4.337 0 0013.625 6.5c0-1.477-.773-2.836-2.016-3.633zm-1.312 1.852a.552.552 0 00-.774.211.58.58 0 00.235.773c.281.164.492.469.492.797a.966.966 0 01-.492.82.581.581 0 00-.235.774.553.553 0 00.774.211A2.064 2.064 0 0011.375 6.5c0-.727-.422-1.43-1.078-1.781zM7.789 2a.487.487 0 00-.375.188L5.328 4.25h-2.39a.555.555 0 00-.563.563v3.375c0 .328.234.562.563.562h2.39l2.086 2.086a.467.467 0 00.375.164c.305 0 .586-.211.586-.562V2.586A.58.58 0 007.789 2zM7.25 9.102L5.773 7.625H3.5v-2.25h2.273L7.25 3.922v5.18z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume.365c73af.svg";
export { ForwardRef as ReactComponent };